<template>
  <div class="pc-list" ref="list">
    <Search @search="search" @changeTag="changeTag" ref="reSearch" />

    <div class="pc-list-head">
      <div class="pc-list-head-handle clearfix">
        <el-checkbox
          v-model="isSelectAll"
          @change="selectAll"
          class="select-all"
          >{{ "已选" + checked.length + "个" }}</el-checkbox
        >
        <p class="total">{{ "共" + dataArgs.total + "条" }}</p>
        <div class="pc-list-head-btn">
          <button @click="reviewDream(0)">删除全选</button>
          <span></span>
          <button @click="reviewDream(1)">通过全选</button>
        </div>
      </div>
    </div>

    <div class="dream-data">
      <div
        v-for="item in dreamList"
        :key="item.id"
        class="dream-data-item clearfix"
      >
        <el-checkbox
          class="select-item"
          v-model="item.isSelect"
          @change="singleCheck(item)"
        ></el-checkbox>
        <div class="user-info">
          <img v-if="item.user.user_image" :src="item.user.user_image" alt="" />
          <div class="user-img" v-if="!item.user.user_image"></div>
          <div class="user-desc">
            <p>{{ item.user.username }}</p>
            <p>设置禁言</p>
          </div>
        </div>
        <div class="content">
          <div class="first-line clearfix">
            <p class="city">
              {{ item.update_time }} &nbsp;|&nbsp; {{ item.city.name }} | &nbsp;
            </p>
            <p
              class="tag"
              v-if="
                $global.ENUM.URBANDREAMCARDS.find((v) => v.id == item.tag_id)
              "
            >
              {{
                $global.ENUM.URBANDREAMCARDS.find((v) => v.id == item.tag_id)
                  .name
              }}/{{
                $global.ENUM.URBANDREAMCARDS.find((v) => v.id == item.tag_id)
                  .englishName
              }}
              |&nbsp;
            </p>

            <p class="response" v-if="item.parent_content">回复:</p>
            <p class="response-content" v-if="item.parent_content">
              {{ item.parent_content }}
            </p>
          </div>

          <p class="question-content">
            {{ item.content }}
          </p>
        </div>
        <button class="btnViewDetail" @click="reviewDream(0,item._id)"  v-if='!(dataArgs.audit ==null && dataArgs.status ==0)'>
          删除
        </button>
        <button class="btnViewDetail" @click="reviewDream(1,item._id)"  v-if='!(dataArgs.audit ==1 && dataArgs.status ==1)'>
          通过
        </button>
      </div>
    </div>

    <Pagination
      v-if="dreamList.length > 0"
      class="pagination"
      :pagination="dataArgs"
      @goPage="goPage"
      @handleCurrentChange="goPage"
      @goLastPage="goPage"
      @goFirstPage="goPage"
    />
    <ExportTable
      :tableData="selectedItems"
      :exportFeild="exportFeild"
      ref="exportTable"
    />
    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
      :moduleName="'城市群'"
      :subName="'城市'"
    />
  </div>
</template>



<script>
import DeleteHint from "../../../template/DeleteHint.vue";
import Pagination from "../../../template/Pagination";
import ExportTable from "../../../template/exportTable.vue";
import Search from "./Search";
import { deleteCityGroups } from "./regionList.gql";

export default {
  components: {
    Search,
    DeleteHint,
    ExportTable,
    Pagination,
  },
  watch: {},
  data() {
    return {
      deleteDialogVisible: false,
      isSelectAll: false,
      dataArgs: {
        tag_id: null,
        keyword: null,
        type: null,
        city_name: null,
        start: null,
        end: null,
        page: 1,
        take: 10,
        audit: 0,
        status: null,
      },
      dreamList: [],
      checked: [],
      selectedItems: [],
      exportFeild: [
        { label: "ID", prop: "id" },
        { label: "名称", prop: "name" },
        { label: "英文名", prop: "englishName" },
        { label: "所属大洲", prop: "continent" },
        { label: "所属国家", prop: "country" },
        { label: "经度", prop: "lng" },
        { label: "纬度", prop: "lat" },
        { label: "英文简介", prop: "englishIntro" },
        { label: "中文简介", prop: "intro" },
        { label: "封面图", prop: "bgImage" },
        { label: "收藏人数", prop: "collectNums" },
        { label: "浏览人数", prop: "nums" },
        { label: "城市数", prop: "cityNums" },
        { label: "标签", prop: "tags" },
        { label: "数据更新时间", prop: "updateTime1" },
        { label: "数据录入时间", prop: "createTime1" },
        { label: "面积", prop: "area" },
        { label: "人口", prop: "population" },
        { label: "GDP", prop: "gdp" },
        { label: "状态", prop: "status1" },
      ],
    };
  },

  mounted() {
    this.getDreams();
  },
  methods: {
    changeTag(val) {
      this.dataArgs.tag_id = val.tag_id;
      this.dataArgs.keyword = val.keyword;
      this.dataArgs.type = val.type;
      this.dataArgs.city_name = val.city_name;
      this.dataArgs.start = val.start;
      this.dataArgs.end = val.end;
      this.dataArgs.page = 1;
      this.dataArgs.audit = val.audit;
      this.dataArgs.status = val.status;
      this.getDreams();
    },
    getDreams() {
      this.$axios.get("urban_bg_search", this.dataArgs).then((res) => {
        this.dreamList = res.data;
        this.$set(this.dataArgs, "total", res.count);
      });
    },

    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.selectedItems = [];
        this.dreamList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item._id);
          this.selectedItems.push(item);
        });
      } else {
        this.dreamList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
          this.selectedItems = [];
        });
      }
    },
    // 单选按钮
    singleCheck(item) {
      if (item.isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == item._id) {
            this.checked.splice(i, 1);
            // this.selectedItems.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(item._id);
        this.selectedItems.push(item);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
      console.log(this.checked);
    },
    search(val) {
      console.log(val);
      this.dataArgs.tag_id = val.tag_id;
      this.dataArgs.keyword = val.keyword;
      this.dataArgs.type = val.type;
      this.dataArgs.city_name = val.city_name;
      this.dataArgs.start = val.start;
      this.dataArgs.end = val.end;
      this.dataArgs.page = 1;
      this.getDreams();
    },
    // 删除
    deleteDream() {
      this.deleteDialogVisible = true;
    },
    //
    reviewDream(item,id) {
      if(id){
        this.checked.push(id)
        console.log(this.checked)
      }
      this.$axios.get("urban_bg_review", {content_id: JSON.stringify(this.checked),release:item}).then((res) => {
        this.checked=[]
        this.getDreams()
      });
    },

    // 导出数据
    exportDream() {
      this.$refs.exportTable.exports();
    },
    goPage(data) {
      this.dataArgs.page = data;
      this.getDreams();
      window.scrollTo(0, this.$refs.list.offsetTop);
    },
    isDelete() {
      let data = { ids: this.checked };
      // for (let i = 0; this.checked.length > i; i++) {
      this.$global
        .GraphqlMutation(this, deleteCityGroups, {
          data: data,
        })
        .then((res) => {
          // this.getRegions();
          this.deleteDialogVisible = false;
        });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
  },
};
</script>


<style lang="scss" scoped>
.pc-list {
  margin-top: 40px;
  padding: 60px 20px 55px 40px;
  border-radius: 4px;
  box-shadow: $shadowCard;
  .pc-list-head {
    margin-top: 40px;
    border-top: 1px solid #c0c0c0;
    padding-top: 35px;
    margin-bottom: 35px;
    letter-spacing: 1px;
    font-family: $chinese;
    font-size: 14px;
    color: $mainTitle;
    .pc-list-head-handle {
      align-items: center;
      margin-bottom: 20px;
      .select-all {
        float: left;
      }
      .pc-list-head-btn {
        float: right;
        display: flex;
        border: 1px solid $schoolTagBorder;
        margin-right: 30px;
        border-radius: 4px;
        button,
        p {
          cursor: pointer;
          font-family: $chinese;
          font-size: 14px;
          color: $mainTitle;
          letter-spacing: 1px;
        }

        button {
          width: 100px;
          background: none;
          outline: none;
          padding: 10px 0px;
          box-sizing: content-box;
          border: none;
        }
        span {
          height: 16px;
          border: 1px solid $schoolTagBorder;
          align-self: center;
        }
        button:hover {
          background: $blueBtn;
          color: white;
        }
        p {
          margin-left: 32px;
        }
      }
      .total {
        float: right;
        margin-top: 10px;
      }
    }
  }
  .dream-data {
    border-top: 1px solid $schoolTagBorder;
    .dream-data-item {
      display: flex;
      align-items: start;
      padding-top: 20px;
      padding-bottom: 30px;
      border-bottom: 1px solid $schoolTagBorder;
      .select-item {
        //  float:left;
        margin-top: 12px;
        margin-right: 30px;
      }
      .user-info {
        // float: left;
        display: flex;
        align-items: center;
        .user-img {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          border: 1px solid $timeBtn;
          margin-right: 10px;
          flex-shrink: 0;
        }

        img {
          width: 45px;
          height: 45px;
          object-fit: cover;
          border-radius: 50%;
          margin-right: 10px;
        }
        .user-desc {
          width: 140px;
          flex-shrink: 0;

          p {
            font-size: 14px;
          }
          p:nth-of-type(2) {
            color: $blueBtn;
          }
        }
      }
      .content {
        float: left;
        width: calc(100% - 450px);
        margin-right: 40px;
        .first-line {
          font-size: 14px;
          width: 100%;
          margin-bottom: 8px;
          .city {
            line-height: 20px;
            float: left;
          }
          .tag {
            line-height: 20px;
            float: left;
          }
          .response {
            line-height: 20px;
            float: left;
          }
          .response-content {
            line-height: 20px;
            // font-size: 14px;
            color: $timeBtn;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .question-content {
          font-size: 14px;
        }
        // width:80%;
        //  flex-shrink: 0;
      }
      .btnViewDetail {
        margin-right: 20px;
        float: right;
        flex-shrink: 0;
        width: 50px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid $timeBtn;
        outline: none;
        background: none;
        font-family: $chinese;
        font-size: 12px;
        color: $timeBtn;
        cursor: pointer;
      }
      .btnViewDetail:hover {
        background: $blueBtn;
        color: white;
      }
    }
  }

  .pagination {
    margin-top: 45px;
  }
  /deep/ .pc-pagin {
    justify-content: flex-end !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/audit/urbanDream/regionTable.vue